import { useCallback, useContext } from 'react';

import { RootHistoryContext } from '@swf/core/providers/RootHistoryContextProvider';

const useNavigate = () => {
  const history = useContext(RootHistoryContext);

  return useCallback((path: string) => history?.push(path), [history]);
};

export default useNavigate;
